import { DASH } from '#/utils/constants';

export function NoData() {
  return (
    <>
      <span aria-hidden="true">{DASH}</span>
      <span className="sr-only">Not available</span>
    </>
  );
}
